import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import SponsorPage from "@/components/SponsorPage";
import AboutPage from "@/components/AboutPage";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import CookiesPolicy from "@/components/CookiesPolicy";
import IntakeModal from "@/components/IntakeModal";
import OfflineBanner from "@/components/OfflineBanner";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { getPendingCount, installAutoFlush } from "@/lib/intakeQueue";
import { track } from "@/lib/analytics";

function Shell() {
  const navigate = useNavigate();
  const location = useLocation();

  const [modalOpen, setModalOpen] = useState(false);
  const [preferredBundle, setPreferredBundle] = useState("");
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine !== false : true
  );
  const [pending, setPending] = useState(getPendingCount());

  useEffect(() => {
    const stop = installAutoFlush(({ pending: p, online: o }) => {
      setPending(p);
      setOnline(o);
    });
    return stop;
  }, []);

  // Reset scroll on route change + emit a custom analytics event for SPA navs
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    track("page_view", { path: location.pathname });
  }, [location.pathname]);

  const openIntake = (bundleLabel = "") => {
    setPreferredBundle(bundleLabel);
    setModalOpen(true);
  };

  const isHome = location.pathname === "/sponsor-a-relative";

  return (
    <div className="hr-app-root flex flex-col min-h-screen">
      <OfflineBanner online={online} pending={pending} />
      <Header
        onHome={() => navigate("/sponsor-a-relative")}
        onAbout={() => navigate("/about")}
        currentPath={location.pathname}
      />

      <div className="flex-1">
        <Routes>
          {/* Root explicitly redirects to /sponsor-a-relative so we never lose paid traffic */}
          <Route path="/" element={<Navigate to="/sponsor-a-relative" replace />} />
          <Route
            path="/sponsor-a-relative"
            element={<SponsorPage onBook={openIntake} isHome />}
          />
          <Route path="/about" element={<AboutPage />} />
          <Route
            path="/privacy"
            element={<PrivacyPolicy onBack={() => navigate(-1)} />}
          />
          <Route
            path="/cookies"
            element={<CookiesPolicy onBack={() => navigate(-1)} />}
          />
          {/* Anything else redirects to the sponsor landing */}
          <Route path="*" element={<Navigate to="/sponsor-a-relative" replace />} />
        </Routes>
      </div>

      <Footer
        onOpenPrivacy={() => navigate("/privacy")}
        onOpenCookies={() => navigate("/cookies")}
        onOpenAbout={() => navigate("/about")}
        onOpenSponsor={() => navigate("/sponsor-a-relative")}
      />

      <FloatingWhatsApp />

      <IntakeModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setPending(getPendingCount());
        }}
        audience="sponsor"
        preferredBundle={preferredBundle}
        isOnline={online}
        onOpenPrivacy={() => {
          setModalOpen(false);
          navigate("/privacy");
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
